import { render, staticRenderFns } from "./UploadedFilesModal.vue?vue&type=template&id=3aed55be&scoped=true&"
import script from "./UploadedFilesModal.vue?vue&type=script&lang=js&"
export * from "./UploadedFilesModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadedFilesModal.vue?vue&type=style&index=0&id=3aed55be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aed55be",
  null
  
)

export default component.exports